import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/system";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { handleDatePickerShortcuts } from "../../../utils/keyboardShortcutHelpers";
import StyledDateTimePicker from "../StyledDateTimePicker/StyledDateTimePicker";
import StyledFormHelperText from "../StyledFormHelperText/StyledFormHelperText";

export default function PrimaryDateTimePicker({
  label,
  value,
  handleChange,
  onBlur,
  width,
  ampm,
  error,
  disabled,
  helperText
}) {
  const [pressedKeys, setPressedKeys] = useState({});

  const handleKeyDown = useCallback((event) => {
    handleDatePickerShortcuts(event, pressedKeys, setPressedKeys, value, handleChange);
  }, [value]);

  const handleKeyUp = useCallback((event) => {
    const keys = pressedKeys;
    delete keys[event.key];

    setPressedKeys(keys);
  }, []);

  return (
    <Box sx={{ display: "inline" }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <StyledDateTimePicker
          label={label}
          value={value}
          onChange={(newValue) => {
            handleChange(newValue);
          }}
          sx={{ width: width }}
          disabled={disabled}
          ampm={ampm}
          timeSteps={{ minutes: 1 }}
          slotProps={{
            textField: {
              size: "small",
              onKeyDown: handleKeyDown,
              onKeyUp: handleKeyUp,
              onBlur: onBlur,
              error: error,
            },
            popper: {
              sx: { boxShadow: "elevation1" },
            }
          }}
        />
      </LocalizationProvider>
      <StyledFormHelperText error={error} disabled={disabled}>{helperText}</StyledFormHelperText>
    </Box>
  );
}

PrimaryDateTimePicker.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string
  ]),
  handleChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  width: PropTypes.string,
  ampm: PropTypes.bool,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  helperText: PropTypes.string
};